import apiClient from '../apiClient';
import { POST_ACCOMODATION_ITEM_URL } from '../apiUrl';

const postAccomodationItemApi = data => {
  return apiClient.post(POST_ACCOMODATION_ITEM_URL, data);
};

export default postAccomodationItemApi;
